<template>
  <div class="wizard-breadcrumb">
    <div class="visible-xs back-link">
      <template v-if="links.length === 1">
        {{ links[0].label }}
      </template>
      <router-link v-else :to="{ path: getParentPath(links) }">
        <dotcom-icon
          name="arrow-right"
          art="light"
          rotation="180"
          color="--c-primary-neutral-3"
        />
        {{ backLabel }}
      </router-link>
    </div>
    <ul class="hidden-xs">
      <li v-for="(link, i) in links" :key="i">
        <router-link v-if="link.path" :to="{ path: link.path }">
          {{ link.label }}
        </router-link>
        <template v-else>
          {{ link.label }}
        </template>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'WizardBreadcrumb',
  components: {
    DotcomIcon: () => {
      return import(
        /* webpackChunkName: "dotcom-icon" */
        '@/modules/icon/Icon'
      )
    },
  },
  props: {
    backLabel: {
      type: String,
      required: true,
    },
    links: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getParentPath: function (links) {
      if (links.length < 2) {
        return
      }
      return links[links.length - 2].path
    },
  },
}
</script>

<style scoped>
.wizard-breadcrumb {
  display: block;
  overflow: hidden;
  max-width: 100%;
  text-align: right;
  margin-bottom: 10px;
  height: 30px;

  & >>> .dotcom-icon {
    font-size: 12px;
    margin-right: var(--spacing-1);
  }

  * {
    box-sizing: border-box;
  }
  .hidden-xs {
    display: none;
  }

  ul {
    margin: 0;
    padding: 0 !important;
    display: flex;

    li {
      font-style: normal;
      line-height: 1.35;
      color: var(--c-primary-neutral-3);
      font-weight: 700;
      list-style-type: none;
      font-size: 13px;
      white-space: nowrap;

      &:not(:last-of-type):after {
        content: '\27E9';
        padding: 0 10px;
      }

      a {
        color: var(--c-secondary-neutral-2);
        font-weight: normal;
        font-size: 13px;
        border-bottom: 0; /* to prevent style leaking from outside (.com) */

        &:hover {
          border-bottom: 0;
          color: var(--c-primary-neutral-3);
        }
      }
    }
  }

  .back-link {
    font-style: normal;
    line-height: 1.35;
    color: var(--c-primary-neutral-3);
    font-weight: 700;
    font-size: 13px;
    text-align: left;

    a {
      border-bottom: 0 !important;
      color: var(--c-primary-neutral-3);
      font-weight: normal;
      font-size: 13px;

      .dotcom-icon {
        position: relative;
        top: -1px;
      }
    }
  }

  @media (--sm) {
    .visible-xs {
      display: none;
    }
    .hidden-xs {
      display: flex;
    }
  }
}
</style>
